import "./index.css";
import calloutImage from '../../assets/images/callout.webp'

const About = () => {
  return (
    <div className="about-page">
      <section className="contact-hero">
        <div className="contact-hero-image-wrap">
          <img src={calloutImage} alt="Callout" className="contact-hero-image" />
        </div>
        <div className="contact-hero-content">
          <p className="contact-kicker">Family-made gifts and custom creations</p>
          <p className="contact-subtitle">
            Have a custom idea, gift request, or question about our products or services?
            We would love to hear from you.
          </p>
          <a href="/contact" className="contact-button">
            Contact Us
          </a>
        </div>


      </section>

      <section className="about-content">
        <p>
          Hogcloud blends technology expertise with artisan craftsmanship. We offer
          custom, one-of-a-kind gifts, jewelry, magnets, party favors, and decorations
          that are fully customizable and family-made.
        </p>

        <p>
          Founded in 2021 by an Arkansas native, Hogcloud began as a technology company
          specializing in cloud consulting and custom software solutions. Brand new for
          this year, we’ve expanded into unique, handcrafted products, including our
          popular animal-themed line designed and created by Violet as part of our
          family-run business.
        </p>

        <p>
          Rooted in innovation and creativity, Hogcloud combines modern tech solutions
          with artisan, family-made products to bring originality to every project.
        </p>
      </section>

      <section className="video-section">
        <div className="video-card">
          <iframe
            width="400"
            height="225"
            src="https://www.youtube.com/embed/f2cfllgW4iM?si=RIVntXh0HoNkRKNa"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
      </section>

      <section className="legal-note">
        <p>
          Hogcloud, Inc. is a registered Arkansas S-Corporation located in Fayetteville,
          Arkansas. We are not affiliated with, endorsed by, or sponsored by the
          University of Arkansas, the Arkansas Razorbacks, or any of their associated
          organizations. We are simply proud members of the Fayetteville community who
          love supporting the Razorbacks as fans.
        </p>
      </section>
    </div>
  );
};

export default About;